// extracted by mini-css-extract-plugin
module.exports = {"leftMargin":"CustomRadioButton_leftMargin__1nfoE"};